import { render, staticRenderFns } from "./StaffSlider.vue?vue&type=template&id=1ab49aff"
import script from "./StaffSlider.vue?vue&type=script&lang=js"
export * from "./StaffSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports